import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

export const DivisionValidationPaths = {
  NAME: {
    path: 'name',
    message: 'Error: Please enter the divison.',
  },
  DESCRIPTION: {
    path: 'desc',
    message: 'Error: Please enter the description.',
  },
} as const;

export const DivisionValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator.addRule(
    DivisionValidationPaths.NAME.path,
    ValidationRules.required,
    DivisionValidationPaths.NAME.message,
  );

  validator.addRule(
    DivisionValidationPaths.DESCRIPTION.path,
    ValidationRules.required,
    DivisionValidationPaths.DESCRIPTION.message,
  );

  return validator;
};
